// extracted by mini-css-extract-plugin
module.exports = {"searchTermLink":"MW2kL","root":"_2rcQ3","wrapper":"_2uBgc","autosuggestWrapper":"_1NF1t","imageWrapper":"_2Udql","seoHeader":"_3IUKn","image":"_2PR9B","searchTerms":"hRRCI"};